<template>
  <section class="main">
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <div class="table-header">Редактирование баннера</div>
      <router-link class="btn btn-success" to="/list-banners">Назад</router-link>
    </div>
    <div class="mb-3">
      <label class="form-label">Название</label>
      <input type="text" class="form-control" placeholder="Название" v-model="banner.name">
    </div>
    <div class="mb-3">
      <label class="form-label">Месторасположение</label>
      <select class="form-select" v-model="banner.page">
        <option v-for="item in placeList" :key="item.id" :value="item.id">{{ item.name }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Ссылка для веб</label>
      <input type="text" class="form-control" placeholder="Ссылка" v-model="banner.url">
      <div class="form-text">Пример: /product/govyadina_myakot_kubikom</div>
    </div>
    <div class="mb-3">
      <label class="form-label">Выберите товар</label>
      <multiselect v-model="banner.product" :options="this.productListNoFilter" placeholder="Выберите" label="title" track-by="title"></multiselect>
      <div class="form-text">Для мобильного приложения</div>
    </div>
    <div class="mb-3">
      <label class="form-label">Выберите категорию</label>
      <multiselect v-model="banner.category" :options="this.categoryInfo" placeholder="Выберите" label="name" track-by="name"></multiselect>
      <div class="form-text">Для мобильного приложения</div>
    </div>
    <div class="mb-3">
      <label class="form-label">Регион показа</label>
      <select class="form-select" v-model="banner.region">
        <option value="77">Москва</option>
        <option value="78">Санкт-Петербург</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Порядок</label>
      <input type="number" class="form-control" placeholder="Порядок" :min="1" v-model="banner.sort">
    </div>
    <div class="d-flex justify-content-end">
      <button class="btn btn-success" @click="editBanner">Сохранить изменения</button>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect';

export default {
  name: 'edit-banner',
  props: ['id'],
  data: function () {
    return {
      banner: {
        id: this.id,
        name: '',
        page: 0,
        url: '',
        region: 77,
        product: [],
        category: [],
        sort: 1
      },
    }
  },
  computed: mapGetters(['placeList', 'productListNoFilter', 'categoryInfo', 'bannerGet']),
  async mounted() {
    this.getBanner();
    this.getPlaceList();
    this.getProductList();
    this.getCategory();
  },
  methods: {
    getBanner: function(){
      this.$store.dispatch('getBanner', this.id).then(() => {
        this.banner.name = this.bannerGet.name;
        this.banner.page = this.bannerGet.place_id;
        this.banner.url = this.bannerGet.url_pc;
        this.banner.region = this.bannerGet.region;
        this.banner.product = this.bannerGet.product;
        this.banner.category = this.bannerGet.category;
        this.banner.sort = this.bannerGet.sort;
      });
    },
    editBanner: function(){
      this.$store.dispatch('editBanner', this.banner);
    },
    getPlaceList: function(){
      this.$store.dispatch('getBannerPlace');
    },
    getProductList: function(){
      this.$store.dispatch('getProductListNoFilter');
    },
    getCategory: function(){
      this.$store.dispatch('getCategories');
    },
  },
  components: {
    Multiselect
  }
}
</script>